import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  placesSuggestions: ({ disabled }: Props) => ({
    position: 'absolute',
    top: 56,
    right: 0,
    left: 0,
    zIndex: 10,
    backgroundColor: neutral.white,
    border: disabled ? 'none' : `1px solid rgba(0, 0, 0, 0.23)`,
    padding: 0,
  }),
  placeSuggestion: {
    borderBottom: `1px solid rgba(0, 0, 0, 0.23)`,
  },
  disabled: ({ disabled }: Props) => ({
    backgroundColor: disabled ? neutral.D11 : 'none',
  }),
});

interface Props {
  disabled: boolean;
}
